import "../css/CommonDesign.css";
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { TextField, Container, Stack, Button, Typography, Breadcrumbs, Link } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from "axios";
import { API } from "./constantsFront";
import MenuMenu from "./MenuMenu";
import { QLDB } from "aws-sdk";

/**
 * よくあるご質問
 * @returns 
 */
function D00501QuestionList() {

  const navigate = useNavigate();

  const [questionList, setQuestionList] = useState(""); // 質問内容（取得）
  const [categoryList, setCategoryList] = useState(""); // カテゴリー名（取得）
  const [keywordList, setKeywordList] = useState(""); // 注目のキーワード（取得）
  const [inputKeyword, setInputKeyword] = useState(""); // キーワード検索
  const [keywordMsg, setKeywordMsg] = useState(""); // 必須チェック用メッセージ(キーワード)
  const questions = []; // 質問内容（表示）
  const categories = []; // カテゴリー名（表示）
  const keywords = []; // 注目のキーワード（表示）
  let body = { authKey: API.API_KEY };

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 初期表示
  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    // 質問テーブル
    axios.post("/m_question/select/", body).then(res => {
      setQuestionList(res.data.questionList);
    });

    // 質問-カテゴリーテーブル
    // axios.post("/m_que_category/select", body).then(res => {     // 2023/04/28:バックエンドで表示内容を制御するためコメントアウト
    //   setCategoryList(res.data.categoryList);
    // });

    // よくあるご質問-注目のキーワードテーブル
    axios.post("/t_que_keyword/select/", body).then(res => {
      setKeywordList(res.data.keywordList);
    });

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  // カテゴリー名
  // for (let i in categoryList) {                            // 2023/04/28:バックエンドで表示内容を制御するためコメントアウト
  //   let now = new Date();                                 //2023/04/28:公開日時設定のため以下4行追加
  //   if (new Date(categoryList[i].publish_date) > now) {
  //     continue;
  //   }

  //   questions.push(
  //     <p className="table-title">{categoryList[i].category_name}</p>
  //   );

  //   var question_number = 1;
  //   // 質問内容
  //   for (let j in questionList) {
  //     if (new Date(questionList[j].publish_date) > now) { //2023/04/28:公開日時設定のため以下3行追加
  //       continue;
  //     }

  //     if (categoryList[i].category_id == questionList[j].category_id) {
  //       questions.push(

  //         <p className="D005_p" href="#"
  //           onClick={() => navigate("/D00502QuestionDetail", { state: { question: questionList[j].question_id, group: questionList[j].group_id } })} >
  //           <div style={{ display: "flex", alignItems: "center" }}>
  //             <strong style={{
  //               backgroundColor: "#9C2611"
  //               , color: "white"
  //               , padding: "0 5px 0 5px"
  //             }}>
  //               Q
  //               {/* {question_number} */}

  //             </strong><p style={{ margin: "0 8px" }}>{questionList[j].contents_question}</p>
  //             <ArrowForwardIosIcon style={{
  //               padding: "0"
  //               , color: "#9C2611"
  //               , height: "0.5em"
  //               , marginLeft: "auto"
  //             }} />
  //           </div>
  //         </p >
  //       );
  //       question_number = question_number + 1; // 質問番号

  //     }

  //   }
  //   questions.push(<span></span>);
  // }


  // 2023/05/01:質問表示:filter使用
  //カテゴリーIDを入手するfilter
  let QCL = []
  //質問カテゴリーIDのみを取り出す
  for (let i in questionList) {
    QCL.push(questionList[i].category_id)
  }
  //重複を取り除く
  QCL = QCL.filter((element, index) => QCL.indexOf(element) === index)

  for (let i in QCL) {
    //カテゴリーにあった質問のみを取り出す
    let question = []
    question = questionList.filter(element => { return element.category_id == QCL[i] })

    //質問カテゴリー表示
    questions.push(
      <p className="table-title">{question[0].category_name}</p>
    );
    for (let j in question) {
      //質問内容表示                                         
      questions.push(
        <p className="D005_p" href="#"
          onClick={() => navigate("/D00502QuestionDetail", { state: { question: question[j].question_id, group: question[j].group_id } })} >
          <div style={{ display: "flex", alignItems: "center" }}>
            <strong style={{
              backgroundColor: "#9C2611"
              , color: "white"
              , padding: "0 5px 0 5px"
            }}>
              Q
              {/* {question_number} */}

            </strong><p style={{ margin: "0 8px" }}>{question[j].contents_question}</p>
            <ArrowForwardIosIcon style={{
              padding: "0"
              , color: "#9C2611"
              , height: "0.5em"
              , marginLeft: "auto"
            }} />
          </div>
        </p >
      )
    }
    //余白を空ける
    questions.push(<span></span>);
  }

  // 注目のキーワード
  for (let i in keywordList) {
    keywords.push(
      // <Button
      //   href="#"
      //   style={{
      //     borderRadius: "28px"
      //     , textDecoration: "none"
      //     , color: "#27335A"
      //     , padding: "5px 10px 5px 10px"
      //     , whiteSpace: "nowrap"
      //     , margin: "5px 0 5px 10px"
      //   }}
      //   sx={{ backgroundColor: "#EDEEF2" }}
      //   id={keywordList[i].search_kw_id}
      //   onClick={() => keyword_search(keywordList[i].keyword)}
      // >
      //   {keywordList[i].keyword}
      // </Button>
      <input
        type="button"
        style={{ width: "auto", color: "#1B335E", margin: "5px 0 5px 10px", padding: "5px 10px 5px 10px" }}
        value={keywordList[i].keyword}
        id={keywordList[i].search_kw_id}
        class="buttonDefault graylBtn"
        onClick={() => keyword_search(keywordList[i].keyword)} />
    );
  }

  // キーワード検索処理
  async function keyword_search(keyword) {
    console.log('キーワード検索開始');

    if (keyword == '' || keyword == null) {
      console.log('キーワード未入力エラー');
      setKeywordMsg("キーワードを入力して下さい。")
      return;
    }

    // グローバルIP取得
    let ip;
    try {
      await axios.get('https://ipinfo.io').then(res => ip = res.data.ip);
    } catch {
      ip = null;
    }

    return navigate("/D00503QuestionSearchList", { state: { search_keyword: keyword, ipaddr: ip } });
  }

  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Stack spacing={2}>

                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{ fontSize: "14px" }}>
                      よくあるご質問
                    </Typography>
                  </Breadcrumbs>

                  <h1>よくあるご質問</h1>
                  <div className="attention_word">
                    <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
                      <TextField id="outlined-basic" variant="outlined" label="キーワードを入力"
                        type='search'
                        error={Boolean(keywordMsg == "" ? false : true)}
                        helperText={keywordMsg}
                        value={inputKeyword}
                        onChange={e => { setInputKeyword(e.target.value) }}
                        sx={{ width: "100%" }}
                      />
                      <div style={{ textAlign: "right" }}>
                        {/* <Button style={{
                          width: '150px'
                          , borderRadius: "28px"
                          , height: "100%"
                        }}
                          sx={{ backgroundColor: "#22335C" }}
                          onClick={() => keyword_search(inputKeyword)}
                          className="search_button">
                          検索
                        </Button> */}

                        <input type="button"
                          class="decision_button"
                          style={{ marginTop: "3px" }}
                          value="検索"
                          onClick={() => keyword_search(inputKeyword)} />
                      </div>
                    </Stack>

                    <div style={{ marginTop: "10px" }}>
                      <Stack spacing={2} direction={{ xs: 'column', md: 'row' }} >
                        <div style={{
                          backgroundColor: "#22335C"
                          , color: "white"
                          // , verticalAlign:"middle"
                          , padding: "5px 10px 5px 10px"
                          , whiteSpace: "nowrap"
                          , display: "flex"
                          , alignItems: "center"
                        }}>注目のキーワード</div>
                        <div style={{
                          flexWrap: "wrap"
                        }}>
                          {keywords}
                        </div>
                      </Stack>
                    </div>
                  </div>

                  {/* <h4 className="h4tag">検疫に関して、よくあるものを集めてご紹介します。</h4> */}

                  {categories}
                  {questions}

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default D00501QuestionList;